/**
 * Created by Jerker Nord on 2021-01-28.
 */

import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Karen} from "../Karen";

export class KarenZeroBetIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    start(flowStateController:FlowStateController):void {
        SlotGame.apiPlugin.betHandler.zeroBet();
        if(Karen.model.isRestore) {
            SlotGame.keypadPlugin.setZeroBetSpinCounter(Karen.model.parsedInitData.freespinsLeft - 1);
        } else {
            SlotGame.keypadPlugin.setZeroBetSpinCounter(Karen.model.parsedGameData.freespinsLeft - 1);
        }
        flowStateController.finish();
    }
}